import React from 'react';
import Fab from '@material-ui/core/Fab';
import './styles.scss';

const CombinedFab = ({ readOnly, onClick, children }) => {
  return (
    <Fab
      disabled={readOnly}
      classes={{ root: 'combined-fab' }}
      onClick={onClick}
    >
      {children}
    </Fab>
  );
};

export default CombinedFab;